export { default as StrategyProfileMapContent } from './StrategyProfileMapContent';
